import React, { useEffect } from 'react';
import { useSelector } from 'js/store/hooks';
import { MAINTENANCE_MODE_REDUCER } from 'js/store/constants';
import { useTogglePreloader } from 'js/components/system/App/hooks';

import * as hooks from './hooks';
import { MaintenancePage } from './components/MaintenancePage';

export const Maintenance: React.FC = ({ children }) => {
    const togglePreloader = useTogglePreloader();
    const { isMaintenanceModeEnabled } = hooks.useIsMaintenanceEnabled();
    const { isIntegrationScriptFailed } = hooks.useIsIntegrationScriptFailed();
    const isLoading = useSelector((state) => state[MAINTENANCE_MODE_REDUCER].isLoading);

    hooks.useGetMaintenanceData();

    useEffect(() => {
        if (!isLoading && isMaintenanceModeEnabled || !isLoading && isIntegrationScriptFailed) {
            togglePreloader(true);
        }
    }, [isLoading, isMaintenanceModeEnabled, togglePreloader, isIntegrationScriptFailed]);

    if (isLoading) {
        return null;
    }

    if (isMaintenanceModeEnabled || isIntegrationScriptFailed) {
        return <MaintenancePage />;
    }

    return (
        <>
            {children}
        </>
    );
};
